<template>
    <div class="flex justify-end items-end mb-4">
      <div class="flex flex-col gap-1">
        <div
          class="flex items-center"
          v-for="(types, index) in labels"
          :key="index"
        >
          <div
            class="w-3 h-3 rounded-full"
            :style="`background-color: ${colors[index]}`"
          ></div>
          <span class="mr-2 text-xs text-gray-700">
            {{ types }}
          </span>
        </div>
      </div>
    </div>
</template>

<script>
    export default{
        props: ["labels", "colors"],
    }
</script>